import React from 'react';
import './TopPick.css';

const TopPick = ({ item, onGenerateSimilar }) => {
  if (!item) return null;

  const getVerdictClass = (verdict) => {
    switch (verdict) {
      case 'BUY': return 'tp-verdict-buy';
      case 'WATCH': return 'tp-verdict-watch';
      case 'AVOID': return 'tp-verdict-avoid';
      default: return '';
    }
  };

  return (
    <div className="top-pick">
      <div className="top-pick-label">TOP PICK</div>
      <div className="top-pick-body">
        <div className="top-pick-main">
          <h3 className="top-pick-name">{item.name}</h3>
          <div className="top-pick-metrics">
            <div className="tp-metric">
              <span className="tp-metric-label">Score</span>
              <span className="tp-metric-value tp-score">{item.opportunityScore}</span>
            </div>
            <div className="tp-metric">
              <span className="tp-metric-label">Verdict</span>
              <span className={`tp-metric-value tp-verdict ${getVerdictClass(item.verdict)}`}>
                {item.verdict}
              </span>
            </div>
            <div className="tp-metric">
              <span className="tp-metric-label">30d Growth</span>
              <span className="tp-metric-value tp-growth">+{item.growth30d}%</span>
            </div>
            <div className="tp-metric">
              <span className="tp-metric-label">12m Projection</span>
              <span className="tp-metric-value tp-projection">{item.growthProjection12m}</span>
            </div>
          </div>
        </div>
        <div className="top-pick-why">
          <p className="tp-why-text">{item.whyNow}</p>
          {onGenerateSimilar && (
            <button className="tp-similar-btn" onClick={onGenerateSimilar}>
              Generate Similar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopPick;
